import instance from '@/http/http.js';

//基金基本信息
function funddetail(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Fund/detail',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股票行业
function detailPortfolioStock(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Fund/detailPortfolioStock',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

export { detailPortfolioStock, funddetail };